export const DOCUMENT_ELEMENT = document.documentElement;
export const ROOT_ELEMENT = document.querySelector('[data-role="root"]');
export const SCROLL_ELEMENT = document.body;
export const ROOT_CLASS = 'application';
export const SCROLLBAR_PADDING_SELECTORS = ['body', 'header', '[data-role="preloader"]'];
export const SCROLLBAR_MARGIN_SELECTORS = ['[data-role="scroll-to-top"]'];
export const SELECTORS = {
  // triggers
  active: 'is-active',
  hidden: 'is-hidden',
  disabled: 'is-disabled',
  current: 'is-current',
  loading: 'is-loading',
  loaded: 'is-loaded',
  invalid: 'is-invalid',

  // modals
  menu_opened: 'menu-opened',
  has_modal: 'has-modal',
  has_cookies: 'has-cookies',
  has_preloader: 'has-preloader',
  preloader_start: 'preloader-start',
  video_modal_opened: 'video-modal-opened',
  gallery_modal_opened: 'gallery-modal-opened',

  main_wrapper: '.ccm-page',
  edit_mode: '.ccm-edit-mode',
};

export const KEY_CODES = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  ctrl: 17,
  alt: 18,
  esc: 27,
  space: 32,
  arrow_left: 37,
  arrow_up: 38,
  arrow_right: 39,
  arrow_down: 40,
  left_window_key: 91,
};

export const FORM_ELEMENTS = {
  input_block: '[data-role*="input-block"]',
  input_block__input: '[data-role*="input"]',
  input_block__label: '[data-role*="label"]',
  input_block__error: '[data-role*="error"]',
  captcha_block: '[data-role*="captcha-block"]',
  content_block: '[data-role*="content-block"]',
  message_block: '[data-role*="message-block"]',
  message_loader: '[data-role*="message-loader"]',
  message_success__text: '[data-role*="success-text"]',
  message_success__mark: '[data-role*="success-mark"]',
  message_error__text: '[data-role*="error-text"]',
  message_error__mark: '[data-role*="error-mark"]',
};

export const FORM_EVENTS = {
  validation_start: 'hevens-form:validation-start',
  validation_success: 'hevens-form:validation-success',
  validation_fail: 'hevens-form:validation-fail',
  submit_start: 'hevens-form:submit-start',
  submit_success: 'hevens-form:submit-success',
  submit_fail: 'hevens-form:submit-fail',
};


export const BREAKPOINTS = {
  l: 1023,
  s: 639,
};

export const EVENTS = {
  preloaderStart: Symbol('PRELOADER:START'),
  preloaderEnd: Symbol('PRELOADER:END'),
  modalToggle: Symbol('MODAL:TOGGLE'),
  menuToggle: Symbol('MENU:TOGGLE'),
  lazyImages_update: Symbol('LAZY-IMAGES:UPDATE'),
  lazyImages_loadForce: Symbol('LAZY-IMAGES:LOAD-FORCE'),
  lazyImages_imageLoaded: Symbol('LAZY-IMAGES:IMAGE-LOADED'),
  loadingStart: Symbol('LOADING:START'),
  loadingEnd: Symbol('LOADING:END'),
  ctaHide: Symbol('CTA:HIDE'),
  ctaShow: Symbol('CTA:SHOW'),
};



// WEBPACK FOOTER //
// ./scripts/constants.js